import React from 'react';
import {useNavigate} from 'react-router-dom';
import {PageTitle} from 'ui';
import styles from '../OfferPage.module.css';

export interface OfferHeaderTitleProps {
	title: string;
	price: string;
	invited?: boolean;
	applied?: boolean;
}

function BackIcon(): React.ReactElement {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path d="M10 6L4 12L10 18" stroke="black" strokeWidth="1.6" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 12.9135L5 12.9135L5 11.1992L20 11.1992L20 12.9135Z"
				fill="black"
			/>
		</svg>
	);
}

export function OfferHeaderTitle({title, price, invited, applied}: OfferHeaderTitleProps): React.ReactElement {
	const navigate = useNavigate();
	const mobileStatus = applied ? 'Вы откликнулись' : invited ? 'Вас пригласили' : 'Предложение';

	return (
		<div className="min-w-0">
			<div className="mb-3 flex w-full min-w-0 items-center gap-2 sm:hidden">
				<button
					type="button"
					className="-ml-2 inline-flex shrink-0 items-center justify-center rounded-lg p-2 text-black hover:bg-black/5 active:bg-black/10"
					onClick={() => navigate(-1)}
					aria-label="Назад"
				>
					<BackIcon />
				</button>
				<span className="min-w-0 flex-1 text-center text-base font-medium text-black">{mobileStatus}</span>
				<div className="w-10 shrink-0" aria-hidden />
			</div>

			<button
				type="button"
				className="mb-5 hidden items-center gap-2.5 rounded-lg px-1 py-1 text-base font-medium text-black hover:bg-black/5 sm:flex"
				onClick={() => navigate(-1)}
			>
				<BackIcon />
				Назад
			</button>

			{invited && !applied ? <span className={styles.inviteBadge}>Вас пригласили</span> : null}

			<PageTitle className={styles.headerTitle}>{title}</PageTitle>
			<p className={styles.priceRow}>
				<span className={styles.price}>{price}</span>
				<span className={styles.priceHint}>до вычета налогов</span>
			</p>
		</div>
	);
}
